// ツールボックス定義（旧ビルダープレビュー Toolbox.tsx から復元・enabledCommands 対応）
// CUSTOM_FLYOUT で動的にブロック一覧を返す。一覧は enabledCommands で絞り込む。

import { BuilderCommandId, CommandLimits } from "features/builder/types";
import { BlockType, ToolboxBlock, ToolboxDefinition } from "./type";

export const Toolbox: ToolboxDefinition = {
  kind: "categoryToolbox",
  contents: [
    {
      kind: "category",
      toolboxitemid: "category",
      expanded: "true",
      custom: "CUSTOM_FLYOUT",
    },
  ],
};

// 色ピッカー shadow 付きの色条件ブロック生成ヘルパー
const colourShadow = {
  COLOUR: {
    shadow: {
      type: BlockType.COLOUR_PICKER_INTERNAL,
      fields: { COLOUR: "#71cdfc" },
    },
  },
};

// BuilderCommandId → フライアウトに出すブロック定義
export const COMMAND_TO_BLOCK: Record<BuilderCommandId, ToolboxBlock | null> = {
  [BuilderCommandId.MOVE_FORWARD]: { kind: "block", type: BlockType.MOTION_MOVE },
  [BuilderCommandId.TURN_LEFT]: { kind: "block", type: BlockType.MOTION_TURN_LEFT },
  [BuilderCommandId.TURN_RIGHT]: { kind: "block", type: BlockType.MOTION_TURN_RIGHT },
  [BuilderCommandId.JUMP]: { kind: "block", type: BlockType.MOTION_JUMP },
  [BuilderCommandId.LOOP]: {
    kind: "block",
    type: BlockType.CONTROLS_REPEAT_INTERNAL,
    extraState: { max: 5 },
  },
  [BuilderCommandId.IF_COLOR]: {
    kind: "block",
    type: BlockType.CONTROLS_IF_COLOUR_INTERNAL,
    inputs: colourShadow,
  },
  [BuilderCommandId.WHILE_COLOR]: {
    kind: "block",
    type: BlockType.CONTROLS_WHILEUNTIL_COLOUR_INTERNAL,
    inputs: colourShadow,
  },
};

// enabledCommands の順序でフライアウトのブロック一覧を組み立てる
export const buildFlyoutContents = (enabledCommands: BuilderCommandId[]): ToolboxBlock[] =>
  enabledCommands.map((cmd) => COMMAND_TO_BLOCK[cmd]).filter((b): b is ToolboxBlock => b !== null);

// CommandLimits（コマンド ID キー）→ Blockly の maxInstances（ブロック型キー）へ変換。
// 無制限（キーなし）のコマンドは含めない。
export const buildMaxInstances = (limits: CommandLimits): { [type: string]: number } => {
  const maxInstances: { [type: string]: number } = {};
  (Object.keys(limits) as BuilderCommandId[]).forEach((cmd) => {
    const block = COMMAND_TO_BLOCK[cmd];
    const limit = limits[cmd];
    if (block && limit != null) maxInstances[block.type] = limit;
  });
  return maxInstances;
};
